import { ReactNode } from 'react';
import { makeStyles, TextareaAutosizeProps } from '@material-ui/core';
import TextAreaInputBase from './TextAreaInputBase';
import { Colors, ErrorMessage, FormLabel } from '../helpers';
import { useContextField } from '../../../api';

export default (props: {
    name: string;
    label?: ReactNode;
    placeholder?: string;
    disabled?: boolean;
} & TextareaAutosizeProps) => {
    const [field, _, helper] = useContextField<string | undefined>(props.name);
    const { label, ...rest } = props;
    const classes = useStyles();
    return <>
        <FormLabel label={label} />
        <TextAreaInputBase
            {...rest}
            {...field}
            className={classes.textarea}
            onChange={e => helper.setValue(e.target.value)}
        />
        <ErrorMessage name={field?.name} />
    </>
}

const useStyles = makeStyles({
    textarea: {
        font: 'inherit',
        fontSize: '1rem',
        letterSpacing: 'inherit',
        color: Colors.Black,
        border: `1px solid ${Colors.Grey}`,
        borderRadius: '0.75rem',
        width: '100%',
        resize: 'none',
        padding: '11px 15px 12px 15px',
        '&&&::-webkit-input-placeholder': {
            color: Colors.Grey
        },
        '&&&::-moz-placeholder': {
            color: Colors.Grey
        },
        '&&&::placeholder': {
            color: Colors.Grey
        },
        '&&&:focus-visible': {
            border: `1px solid ${Colors.Blue}`,
            outline: `1px solid ${Colors.Blue}`
        },
        '&&&:hover:not(:focus-visible)': {
            border: `1px solid ${Colors.Black}`
        }
    }
}, { name: 'TextAreaInput' });
